import { state_ctrl_factory_method } from 'ww2_analytics/common/state_ctrl';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory_method('retention.first_24h_table', function($scope, resp) {
        Object.assign($scope, resp);
    }),
};
const state_config = {
    url: '/first_24h',
    reloadOnSearch: false,
    data: {
        priority: 890,
        title: 'First 24h',
    },
    views: {
        '': main_view,
    },
};
export default state_config;
